import { api } from 'api/axios';
import { Subject } from '../types/subject';

export const subjectApi = {
    getAll: async () => {
        const response = await api.get<{ data: Subject[] }>('/subjects');
        return response.data;
    },

    getById: async (id: string) => {
        const response = await api.get<{ data: Subject }>(`/subjects/${id}`);
        return response.data;
    },

    getBySlug: async (slug: string) => {
        const response = await api.get<{ data: Subject }>(`/subjects/slug/${slug}`);
        return response.data;
    },

    create: async (data: Partial<Subject>) => {
        const response = await api.post<{ data: Subject }>('/subjects', data);
        return response.data;
    },

    update: async (id: string, data: Partial<Subject>) => {
        const response = await api.patch<{ data: Subject }>(`/subjects/${id}`, data);
        return response.data;
    }
};
